import React from 'react';


export default () => (
    <form id="frmLogout" role="form">
        <h2>Bol si odhlásený!</h2>
    </form>
  );



// WEBPACK FOOTER //
// ./src/app/components/user/logout.jsx